import { useEffect, useMemo, useState } from 'react';
import { Box, LinearProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { Environment } from '../../../shared/environment';
import { DashboardEstoqueService, IDashboardProdList } from '../../../shared/services/api/estoque/dashboard/DashboardEstoqueService';
import dayjs from 'dayjs';

export const ListagemDashboardEntradaTrans: React.FC<{ idprod: string, idLocalizacao: string }> = ({ idprod, idLocalizacao }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [rows, setRows] = useState<IDashboardProdList[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina2') || '1');
  }, [searchParams]);

  useEffect(() => {
    setIsLoading(true);
    if (idprod !== '' && idLocalizacao !== '') {
      DashboardEstoqueService.DashboardProdListEntTrans(pagina, idprod, idLocalizacao)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            alert(result.message);
          } else {
            setRows(result.data);
            setTotalCount(result.totalCount);
          }
        });
    }

  }, [pagina, idprod, idLocalizacao]);

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="center"
      >
        <Typography
          component="span"
          sx={{
            fontFamily: 'Arial, sans-serif'
          }}
        >
         Transferencia de Entrada
        </Typography>
      </Box> 
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table size="small" sx={{background: '#a8f5cf0c', opacity: 1}}>
          <TableHead>
            <TableRow>
              <TableCell>Origem</TableCell>
              <TableCell align='center' sx={{ fontSize: 11 }}>Emissão</TableCell>
              <TableCell align='right' sx={{ fontSize: 11 }}>Quant.</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.iditens} hover sx={{ cursor: 'pointer' }}>
                <TableCell sx={{ fontSize: 11 }}>{row.origem}</TableCell>
                <TableCell align='center' sx={{ fontSize: 11 }}>{dayjs(row.dataemissao).format('DD/MM/YYYY')}</TableCell>
                <TableCell align='right' sx={{ fontSize: 11 }}>{row.quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          {totalCount === 0 && !isLoading && (
            <caption>{Environment.LISTAGEM_VAZIA}</caption>
          )}
          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={4}>
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(totalCount > 0 && totalCount > 8) && (
              <TableRow>
                <TableCell colSpan={4}>
                  <Pagination
                    page={pagina}
                    count={Math.ceil(totalCount / 8)}
                    onChange={(_, newPage) => setSearchParams({ pagina2: newPage.toString() }, { replace: true })}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
    </Box>
  );
};